import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

export default function LandingPage() {
  const navigate = useNavigate();
  return (
    <div className="landing">
      <div className="landing-shell">
        <section className="landing-hero">
          <div className="landing-copy">
            <div className="landing-top">
              <div className="landing-logo">
                <img src="/assets/razzberry-white-logo-200.png" alt="Razzberry" />
                <span className="landing-logo-title">Razzberry</span>
              </div>
              <span className="landing-tag">Product Platform</span>
            </div>
            <h1>Sell collectibles.</h1>
            <p>Razzberry helps music artists build fans through digital collectibles with one clean product and unit system.</p>
            <div className="landing-actions">
              <button type="button" onClick={() => navigate('/signin')}>Sign In</button>
              <button type="button" className="ghost" onClick={() => navigate('/signup')}>Create Account</button>
            </div>
          </div>
          <div className="landing-visual">
            <h2>Built for artists.</h2>
            <p>Collectibles are digital and resale-ready.</p>
            <p>Artist pages stay focused on releases, fans, and catalog growth.</p>
          </div>
        </section>
      </div>
    </div>
  );
}
